module.exports = __webpack_public_path__ + "img/eritrea.dc3cf504.svg";